import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import renderSelectField from '../Complements/renderSelectField';
import StandardList from '../Complements/StandardList';
import { isEmpty } from '../../functions/arrays';
import RenderDecimalTextField from '../Complements/renderDecimalTextFiel';
import moment from 'moment'

const useStyles = makeStyles(theme => ({
    textField: {
      width: 200,
    },
    margin: {
      margin: theme.spacing(1),
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid rgba(255, 198, 0)',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
        }
    },
  }));

const validate = values => {
  const error  = {}
  /* if (!values.NumeroPrestamo) {
      error.NumeroPrestamo = "Campo obligatorio"
  } */
  if (!values.Valor) {
      error.Valor = "Campo obligatorio"
  }
  if (!values.Concepto) {
      error.Concepto = "Campo obligatorio"
  }
  return error
}
const CreditsForm = props => {
    const classes = useStyles();
    const { handleSubmit, loans, pristine, onCancelAction, creditSelected, onCreditChange  } = props
    // const { code } = formTaxe

    return (
        <form className={classes.form} onSubmit={ handleSubmit }>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Field
                        name="NumeroPrestamo"
                        id= "NumeroPrestamo"
                        component = { renderSelectField }
                        onChange ={ e => { onCreditChange(e.target.value) } }
                        // value={dateValue}
                        label="Seleccione préstamo a cancelar">
                            <option key = {1} value={''}>{``}</option>
                            {
                                loans.map((v, k) => {
                                    return <option key = {v.Secuencial} value={`${v.Secuencial}-${v.Codigo}`}>{`${v.Codigo} - ${v.Tipo}`}</option>
                                } )
                            }
                    </Field>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <StandardList
                        dataList = { isEmpty(creditSelected) ? [] :
                                [
                                    { id: 1, title: 'Valor a cancelar', data: creditSelected.ValorCancelar},
                                    { id: 2, title: 'Total pagar al dia', data: creditSelected.TotalPagarAlDia},
                                    { id: 3, title: 'Valor Vencido', data: creditSelected.ValorVencido},
                                    { id: 4, title: 'Valor Cuota', data: creditSelected.ValorTotalCuota},
                                    { id: 5, title: 'Próximo Vencimiento', data: moment(creditSelected.ProximoVencimiento).format("YYYY-MM-DD")},
                                ]
                        }
                        primary = {'title'}
                        secondary = {'data'}
                        selectItem = {(val) => {/*console.log(val)*/}}
                        icon = {'local_atm'}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Field
                        withFocus
                        name="Valor"
                        id="Valor"
                        disabled
                        // value = {valuePay}
                        simbol='$'
                        component={ RenderDecimalTextField }
                        label="Monto"
                        fullWidth
                        color = {"#161616"}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                            <Field
                                //withFocus
                                name="Concepto"
                                id="Concepto"
                                required
                                autoFocus = { true }
                                autoComplete="off"
                                //rows="4"
                                //upperCase = { true }
                                component={ RenderTextFieldRedux }
                                label="Concepto"
                                fullWidth
                            />
                        </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" type="submit"
                        fullWidth
                        className = { classes.submit }
                        disabled={pristine }
                        >
                        Pagar
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" fullWidth className={classes.submit} onClick = { () => onCancelAction() }>
                        Cancelar
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

CreditsForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loans: PropTypes.array.isRequired,
    onCancelAction: PropTypes.func.isRequired,
    creditSelected: PropTypes.object.isRequired,
    onCreditChange: PropTypes.func.isRequired,
};

const CreditsFormRedux = reduxForm(
    {
      form: 'CreditsForm',
      enableReinitialize: true,
      validate
    }
)(CreditsForm)
export default CreditsFormRedux

// export default CreditsFormRedux;